<p-toast position="bottom-right"></p-toast>
<p-blockUI [blocked]="blocked"></p-blockUI>
<div class="card m-1">
  <p-breadcrumb [model]="breadItems"></p-breadcrumb>
</div>

<div class="card m-1">
  <div class="card-header bg-gradient-gray-dark text-orange">
    <i class="nav-icon fas fa-chart-line mr-1"></i>
    <strong>
      Graph of :: {{lineName}}
    </strong>
  </div>


  <div class="card-body">
    <div class="row">
      <div class="field col-4">
        <label class="block" style="width:100%">&nbsp;</label>
        <p-button label="Week" icon="pi pi-palette" iconPos="left"
                  [style]="{'width':'45%'}" (onClick)="drawWeek()"></p-button> &nbsp;
        <p-button label="Month" icon="pi pi-palette" iconPos="left"
                  [style]="{'width':'45%'}" (onClick)="drawMonth()"></p-button>
      </div>
      <div class="field col-3">
        <label class="block">From</label>
        <p-calendar [(ngModel)]="fromDate" [showTime]="true" baseZIndex="100" [style]="{'width':'100%'}" appendTo="body" showClear="true"
                    [minDate]="minSelectableDate" [maxDate]="maxSelectableDate"></p-calendar>
      </div>
      <div class="field col-3">
        <label class="block">To</label>
        <p-calendar [(ngModel)]="toDate" [showTime]="true" [style]="{'width':'100%'}" appendTo="body" showClear="true"
                    [minDate]="minSelectableDate" [maxDate]="maxSelectableDate"></p-calendar>
      </div>
      <div class="field  col-2">
        <label class="block">&nbsp;</label>
        <p-button label="Draw" icon="pi pi-palette" iconPos="left"
                  [style]="{'width':'100%'}" (onClick)="DrawGraph()"></p-button>
      </div>
    </div>
    <br />

    <div class="row">
      <div class="col-12">
        <div class="card" style="text-align:center;width:100%;height:515px">
          <div id="chart-line"></div>
          <div id="chart-line2"></div>

        </div>

      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card" style="text-align:center;width:100%;height:515px">
          <div id="chart-line3"></div>
          <div id="chart-line4"></div>

        </div>

      </div>
    </div>
  </div>
</div>
